import store from '..'
import axios from 'axios'
import API from '@/common/api'
import LANG from '@/common/lang'

export default {
  namespaced: true,
  state: {
    list: [],
    submit: {
      cart: false,
      isSubmit: false,
      submitTo: '',
      submitLabel: '',
      subject: LANG.valueObj()
    },
    templates: [],
    templateCategory: []
  },
  mutations: {
    initSubmit (state) {
      state.submit = {
        cart: false,
        isSubmit: false,
        submitTo: '',
        submitLabel: '',
        subject: LANG.valueObj(),
        submitReturnUrl: false,
        submitReturnUrlLink: {
          type: 'page',
          url: LANG.valueObj(),
          pageId: '',
          productId: '',
          target: false
        }
      }
    }
  },
  actions: {
    setListData ({ state }, data) {
      state.list = data
      return true
    },
    setSubmit ({ state }, data) {
      state.submit = Object.assign(state.submit, data)
    },
    setSubmitTo ({ state }, data) {
      state.submit.submitTo = data.id
      state.submit.submitLabel = data.label
    },
    updateSubmits ({ state }, isSubmit) {
      state.submit.isSubmit = isSubmit
    },
    setSubmitData ({ state }, data) {
      state.submit[data.key] = data.value
    },
    async getPageList () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_ALL_PAGE_PARAMS,
          id: store.state.authentication.requestId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setPageList ({ state }, data) {
      try {
        await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'page/list.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async setPageListItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.CREATE_PAGE_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return true
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async updatePageListItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_PAGE_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return true
      } catch (ex) {
        return false
      }
    },
    async delPageListItem ({ state }, ids) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.DELETE_PAGE_PARAMS,
          id: store.state.authentication.requestId,
          pageIds: ids
        })
        return true
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setPageListData ({ dispatch }) {
      return dispatch('getPageList').then(res => {
        const data = !res ? [] : res
        dispatch('setListData', data)
        return data
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
      })
    },
    async getPageItem ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `page/item/${id}.json`
        })
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async setPageItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `page/item/${data.id}.json`,
          data: JSON.stringify(data.data)
        })
        return true
      } catch (ex) {
        return false
      }
    },
    async delPageItem ({ state }, id) {
      try {
        await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.DEL_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `page/item/${id}.json`
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getPageTemplates ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_ALL_PAGE_PARAMS,
          id: 'a.000'
        })
        state.templates = res.data.message.filter(x => x.pageData.state === '01')
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getTemplateCategories ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: 'a.000',
          file: 'category/list.json'
        })
        state.templateCategory = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getTemplateItem ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: 'a.000',
          file: `page/item/${id}.json`
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    list (state) {
      return state.list
    },
    templates: state => state.templates,
    submitData (state) {
      return state.submit
    },
    submitCategory (state) {
      return state.submitCategory
    }
  }
}
